/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DuelsRouteImport } from './routes/duels'
import { Route as DailyRouteImport } from './routes/daily'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WikipartyLobbyIdRouteImport } from './routes/wikiparty.$lobbyId'
import { Route as OpenlobbyLobbyIdRouteImport } from './routes/openlobby.$lobbyId'
import { Route as DailyLobbyIdRouteImport } from './routes/daily.$lobbyId'
import { Route as OpenlobbyLobbyIdScoreRouteImport } from './routes/openlobby.$lobbyId.score'
import { Route as OpenlobbyLobbyIdGameRouteImport } from './routes/openlobby.$lobbyId.game'

const DuelsRoute = DuelsRouteImport.update({
  id: '/duels',
  path: '/duels',
  getParentRoute: () => rootRouteImport,
} as any)
const DailyRoute = DailyRouteImport.update({
  id: '/daily',
  path: '/daily',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WikipartyLobbyIdRoute = WikipartyLobbyIdRouteImport.update({
  id: '/wikiparty/$lobbyId',
  path: '/wikiparty/$lobbyId',
  getParentRoute: () => rootRouteImport,
} as any)
const OpenlobbyLobbyIdRoute = OpenlobbyLobbyIdRouteImport.update({
  id: '/openlobby/$lobbyId',
  path: '/openlobby/$lobbyId',
  getParentRoute: () => rootRouteImport,
} as any)
const DailyLobbyIdRoute = DailyLobbyIdRouteImport.update({
  id: '/$lobbyId',
  path: '/$lobbyId',
  getParentRoute: () => DailyRoute,
} as any)
const OpenlobbyLobbyIdScoreRoute = OpenlobbyLobbyIdScoreRouteImport.update({
  id: '/score',
  path: '/score',
  getParentRoute: () => OpenlobbyLobbyIdRoute,
} as any)
const OpenlobbyLobbyIdGameRoute = OpenlobbyLobbyIdGameRouteImport.update({
  id: '/game',
  path: '/game',
  getParentRoute: () => OpenlobbyLobbyIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/daily': typeof DailyRouteWithChildren
  '/duels': typeof DuelsRoute
  '/daily/$lobbyId': typeof DailyLobbyIdRoute
  '/openlobby/$lobbyId': typeof OpenlobbyLobbyIdRouteWithChildren
  '/wikiparty/$lobbyId': typeof WikipartyLobbyIdRoute
  '/openlobby/$lobbyId/game': typeof OpenlobbyLobbyIdGameRoute
  '/openlobby/$lobbyId/score': typeof OpenlobbyLobbyIdScoreRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/daily': typeof DailyRouteWithChildren
  '/duels': typeof DuelsRoute
  '/daily/$lobbyId': typeof DailyLobbyIdRoute
  '/openlobby/$lobbyId': typeof OpenlobbyLobbyIdRouteWithChildren
  '/wikiparty/$lobbyId': typeof WikipartyLobbyIdRoute
  '/openlobby/$lobbyId/game': typeof OpenlobbyLobbyIdGameRoute
  '/openlobby/$lobbyId/score': typeof OpenlobbyLobbyIdScoreRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/daily': typeof DailyRouteWithChildren
  '/duels': typeof DuelsRoute
  '/daily/$lobbyId': typeof DailyLobbyIdRoute
  '/openlobby/$lobbyId': typeof OpenlobbyLobbyIdRouteWithChildren
  '/wikiparty/$lobbyId': typeof WikipartyLobbyIdRoute
  '/openlobby/$lobbyId/game': typeof OpenlobbyLobbyIdGameRoute
  '/openlobby/$lobbyId/score': typeof OpenlobbyLobbyIdScoreRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/daily'
    | '/duels'
    | '/daily/$lobbyId'
    | '/openlobby/$lobbyId'
    | '/wikiparty/$lobbyId'
    | '/openlobby/$lobbyId/game'
    | '/openlobby/$lobbyId/score'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/daily'
    | '/duels'
    | '/daily/$lobbyId'
    | '/openlobby/$lobbyId'
    | '/wikiparty/$lobbyId'
    | '/openlobby/$lobbyId/game'
    | '/openlobby/$lobbyId/score'
  id:
    | '__root__'
    | '/'
    | '/daily'
    | '/duels'
    | '/daily/$lobbyId'
    | '/openlobby/$lobbyId'
    | '/wikiparty/$lobbyId'
    | '/openlobby/$lobbyId/game'
    | '/openlobby/$lobbyId/score'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DailyRoute: typeof DailyRouteWithChildren
  DuelsRoute: typeof DuelsRoute
  OpenlobbyLobbyIdRoute: typeof OpenlobbyLobbyIdRouteWithChildren
  WikipartyLobbyIdRoute: typeof WikipartyLobbyIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/duels': {
      id: '/duels'
      path: '/duels'
      fullPath: '/duels'
      preLoaderRoute: typeof DuelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/daily': {
      id: '/daily'
      path: '/daily'
      fullPath: '/daily'
      preLoaderRoute: typeof DailyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wikiparty/$lobbyId': {
      id: '/wikiparty/$lobbyId'
      path: '/wikiparty/$lobbyId'
      fullPath: '/wikiparty/$lobbyId'
      preLoaderRoute: typeof WikipartyLobbyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/openlobby/$lobbyId': {
      id: '/openlobby/$lobbyId'
      path: '/openlobby/$lobbyId'
      fullPath: '/openlobby/$lobbyId'
      preLoaderRoute: typeof OpenlobbyLobbyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/daily/$lobbyId': {
      id: '/daily/$lobbyId'
      path: '/$lobbyId'
      fullPath: '/daily/$lobbyId'
      preLoaderRoute: typeof DailyLobbyIdRouteImport
      parentRoute: typeof DailyRoute
    }
    '/openlobby/$lobbyId/score': {
      id: '/openlobby/$lobbyId/score'
      path: '/score'
      fullPath: '/openlobby/$lobbyId/score'
      preLoaderRoute: typeof OpenlobbyLobbyIdScoreRouteImport
      parentRoute: typeof OpenlobbyLobbyIdRoute
    }
    '/openlobby/$lobbyId/game': {
      id: '/openlobby/$lobbyId/game'
      path: '/game'
      fullPath: '/openlobby/$lobbyId/game'
      preLoaderRoute: typeof OpenlobbyLobbyIdGameRouteImport
      parentRoute: typeof OpenlobbyLobbyIdRoute
    }
  }
}

interface DailyRouteChildren {
  DailyLobbyIdRoute: typeof DailyLobbyIdRoute
}

const DailyRouteChildren: DailyRouteChildren = {
  DailyLobbyIdRoute: DailyLobbyIdRoute,
}

const DailyRouteWithChildren = DailyRoute._addFileChildren(DailyRouteChildren)

interface OpenlobbyLobbyIdRouteChildren {
  OpenlobbyLobbyIdGameRoute: typeof OpenlobbyLobbyIdGameRoute
  OpenlobbyLobbyIdScoreRoute: typeof OpenlobbyLobbyIdScoreRoute
}

const OpenlobbyLobbyIdRouteChildren: OpenlobbyLobbyIdRouteChildren = {
  OpenlobbyLobbyIdGameRoute: OpenlobbyLobbyIdGameRoute,
  OpenlobbyLobbyIdScoreRoute: OpenlobbyLobbyIdScoreRoute,
}

const OpenlobbyLobbyIdRouteWithChildren =
  OpenlobbyLobbyIdRoute._addFileChildren(OpenlobbyLobbyIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DailyRoute: DailyRouteWithChildren,
  DuelsRoute: DuelsRoute,
  OpenlobbyLobbyIdRoute: OpenlobbyLobbyIdRouteWithChildren,
  WikipartyLobbyIdRoute: WikipartyLobbyIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
